// extracted by mini-css-extract-plugin
export default {"container":"MainTitle_container__8+K1t","textStyle":"MainTitle_textStyle__2xrgW","colorLight":"MainTitle_colorLight__ySLjn","colorDark":"MainTitle_colorDark__0fcG8"};